import React from "react";
import { Form } from "antd";
import Select from "react-select";

export const FormSelect = ({
  formName,
  required,
  options,
  label,
  initialSelectValue,
  customOnChange,
  isClearable,
  selectStyles,
}) => {
  return (
    <div style={{ margin: "10px 0px " }}>
      <Form.Item
        initialValue={initialSelectValue}
        name={formName}
        label={label}
        rules={required ? [{ required: true, message: "The field is required" }] : []}
      >
        <Select
          isClearable={isClearable}
          onChange={customOnChange && customOnChange}
          styles={{
            menu: (provided) => ({ ...provided, zIndex: 9999 }),
            ...selectStyles,
          }}
          placeholder={label}
          options={options}
        />
      </Form.Item>
    </div>
  );
};

export default FormSelect;
